import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import { routes } from '../../redux/api/routes';
let { pageSizeForGettingProductAvailability } = routes;

import {
	triggerGTMTag
} from '../../redux/util';

import Header from './common/Header';
import Footer from '../common/Footer';
import Loader from '../common/loader';

/*action*/
import {
	saveProductLineNarrowYourResultsFilters,
	getProductLineNarrorYourResultFilters,
	checkAvailabilityGeneric,
	saveProductAvailabilityCallCompleted,
	getProductNumberKeywordResult,
	resetProductAvailabilityResultList,
	getProductLineFilters,
	updateAvailabilityForPreLogin,
	saveGEAccountNumbers,
	validateAccountNumber,
	getShippingAddresses,
	saveShippingAddresses,
	saveProductResultAvailability,
	checkItemOrderability,
	getAddressList,
} from '../../redux/actions';

import {
	updateTagging
} from '../../redux/util';

class PreLoginApp extends Component {

	constructor(props) {
		super(props);
		this.state = {
			history: [],
			itemOrderabilityBatchSize: 200,
		};
		this.checkAvailabilityAndOrderability = this.checkAvailabilityAndOrderability.bind(this);
		this.getSelectedAddressParams = this.getSelectedAddressParams.bind(this);
		this.validateFDD = this.validateFDD.bind(this);
		this.checkIfFP = this.checkIfFP.bind(this);
		this.checkAndSetSearchResult = this.checkAndSetSearchResult.bind(this);
		this.getSelectedAccountNumber = this.getSelectedAccountNumber.bind(this);
		this.getZipCode = this.getZipCode.bind(this);
		this.validateAccountNumber = this.validateAccountNumber.bind(this);
		this.getShippingAddressesDetails = this.getShippingAddressesDetails.bind(this);
	}

	checkIfFP(item) {
		let flag = false;
		// console.log("cond 1", moment(item.finalProductionDate).isSameOrBefore(moment()));
		// console.log("cond 2", !item.availableQty);
		// console.log("cond 3", moment(item.etaDate).isAfter(moment().add(30, "days")));
		if(moment(item.finalProductionDate).isSameOrBefore(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
			(!item.availableQty || item.availableQty === "0" || item.availableQty < item.requestedQuantity) &&
			moment(item.etaDate).isAfter(moment().add(routes.horizon, "days").hours(0).minutes(0).seconds(0).milliseconds(0))
		) {
			flag = true;
		}
		return flag;
	}

	componentWillMount() {
		const self = this;

		self.unlisten = browserHistory.listen( location =>  {
			const { history } = self.state;
			if (location.action === 'PUSH') {
				history.push(location);
			} else if (location.action === 'POP') {
				history.pop();
			}
			self.setState({
				history,
			}, () => {
				// console.log("##### prelogin action: ", location.action);
				if ((location.pathname === '/login' || location.pathname.indexOf('/prelogin') === 0) && (location.action === 'PUSH' || location.action === 'POP')) {
					updateTagging({pathname: window.location.pathname});
				}
			});
		});

		if(self.state.history.length === 0) {
			updateTagging({pathname: window.location.pathname});
		}
	}

	formatETADate(etaDate) {
		const tempDate = moment(etaDate);
		if(tempDate.isValid()) {
			etaDate = moment(etaDate).format('MM/DD/YY');
		}
		return etaDate == 'NA' ? '6+ mos' : etaDate;
	}

	validateFDD(item) {
		const data = JSON.parse(JSON.stringify(item));
		// If the FDD is in the future (>sys date), we need to consider this logic:
		if(item.firstDistributionDate && moment(item.firstDistributionDate).isAfter(moment())) {
			// If there is product available now in DDT, put that qty in Avail (like any model), in the Next Avail column put “NEW” and in the ETA column, put the FDD
			if(item.availableQty && parseInt(item.availableQty, 10) > 0) {
				data.intransitQty = 'NEW';
				data.etaDate = moment(item.firstDistributionDate).format('MM/DD/YY');
			}
			// If the ETA is > (sys date + 365 days), in the Next Avail column put “NEW” and in the ETA column, put the FDD (today I see a qty of 10,000,000,000 and an ETA of 12/21/20 which is not “real” data)
			if(moment(item.etaDate).isAfter(moment().add(routes.horizon, "days"))) {
				data.intransitQty = 'NEW';
				data.etaDate = moment(item.firstDistributionDate).format('MM/DD/YY');
			}
			// If the ETA is < (sys date + 365 days), put the Qty from DDT in Next Avail. In the ETA column, put whichever date is GREATER, the FDD or the ETA from DDT
			if(moment(item.etaDate).isBefore(moment().add(routes.horizon, "days"))) {
				data.intransitQty = item.intransitQty;
				if(moment(item.firstDistributionDate).isAfter(item.etaDate)) {
					data.etaDate = moment(item.firstDistributionDate).format('MM/DD/YY');
				} else {
					data.etaDate = moment(item.etaDate).format('MM/DD/YY');
				}
			}
		}
		// Additionally, for any model that is NOT a future FDD (per above) or FP model and
		// the ETA from DDT is more than 1 year in the future (>sysdate+365) do not show
		// the Next Avail qty and show “NA” in the ETA column.
		else if(item.etaDate && moment(item.etaDate).isAfter(moment().add(routes.horizon, "days"))) {
			data.intransitQty = null;
			data.etaDate = '6+ mos';
		}
		return data;
	}

	getLocTypeData(shippingData, loctype) {
		let data = _.find(shippingData, ["loctype", loctype]);
		if(loctype === "sds_loc") {
			if(!data || (data && (data.agentid === 'NA' || data.agentid === 'NULL' || !data.agentid))) {
				data = _.find(shippingData, ["loctype", 'adc_loc']);
				data = {
					...data,
					isThisADCLOC: true
				}
			}
		}
		return data;
	}

	getShippingAddressesDetails(zipCode, forAvailability, loctype, callback, showLoader = true) {
		const self = this;
		const accountNumber = self.getSelectedAccountNumber();
		let shippingAddressDetail = _.find(this.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: zipCode});
		if(!shippingAddressDetail) {
			self.props.getShippingAddresses(`zip=${zipCode.split('-')[0]}&accountNumber=${accountNumber}`, showLoader, resp => {
				if (resp.responseObject && resp.responseObject.length === undefined) {
					resp.responseObject = [resp.responseObject];
				}
				self.props.saveShippingAddresses({
					zipCode,
					details: resp.responseObject
				});
				callback && callback(self.getLocTypeData(resp.responseObject, loctype));
			});
		} else {
			callback && callback(self.getLocTypeData(shippingAddressDetail.details, loctype));
		}
	}

	validateAccountNumber(index, accountNumber, callback) {
		const self = this;

		if(!accountNumber) {
			return;
		}

		let { userDetails, usersOfAccount, approvedAccounts } = self.props.state.user;
		usersOfAccount = usersOfAccount && usersOfAccount.responseObject ? usersOfAccount.responseObject : [];
		usersOfAccount = usersOfAccount.length > 0 ? _.filter(usersOfAccount, ['userId', userDetails.sso]) : [];

		if(usersOfAccount.length > 0) {
			usersOfAccount = usersOfAccount[0].accounts;
		}
        let isValidAccountNumber = false;
		const { registration } = self.props.state;
		const alreadyApprovedAccountMessage = [],
			alreadyPendingAccountMessage = [];
		let isAlreadyApprovedOrPending = false;

		const accountDetails = registration.geAccountNumbers[index - 1] || {};

		usersOfAccount.length > 0 && registration.geAccountNumbers.map((item, index) => {
			const checkAvailability = _.find(usersOfAccount, ["accountNumber", item.accountNumber]);
			if (checkAvailability && checkAvailability.approvalStatus === "Pending"){
				if(alreadyPendingAccountMessage.indexOf(item.accountNumber) === -1) {
					alreadyPendingAccountMessage.push(item.accountNumber);
					isAlreadyApprovedOrPending = true;
				}
			}
			return null;
		});
		approvedAccounts && approvedAccounts.responseObject && approvedAccounts.responseObject.length > 0 &&
		registration.geAccountNumbers.map((item, index) => {
			const checkAvailability = _.find(approvedAccounts.responseObject, ["ACCOUNTNUMBER", item.accountNumber]);
			if (checkAvailability && checkAvailability.STATUS === "A"){
				if(alreadyApprovedAccountMessage.indexOf(item.accountNumber) === -1) {
					alreadyApprovedAccountMessage.push(item.accountNumber);
					isAlreadyApprovedOrPending = true;
				}
			}
			return null;
		});

		const currentAccIsAlreadyApprovedOrPending = usersOfAccount && _.find(usersOfAccount, ["accountNumber", accountNumber]);
		if(isAlreadyApprovedOrPending && accountNumber !== ""){
			self.props.saveGEAccountNumbers({
				index,
				...accountDetails,
				value: accountNumber,
				valid: false,
				showLoader: false,
				isAlreadyApproved: isAlreadyApprovedOrPending
			});
			// self.props.disableUpdateButton(false);
			callback && callback();
		} else if(!currentAccIsAlreadyApprovedOrPending && accountNumber !== "") {
			self.props.saveGEAccountNumbers({
				index,
				...accountDetails,
				value: accountNumber,
				valid: null,
				showLoader: true,
				isAlreadyApproved: false
			});
			self.props.validateAccountNumber(`accountNumber=${accountNumber}&requestType=getAccountDetails`, response => {
				self.props.getAddressList(`accountNumber=${accountNumber}&partyId=${response.responseObject[0].PARTYID}&requestType=getAddressList`, false, resp => {
					if(resp.responseMessage != "Got the adress list"){
						self.props.saveGEAccountNumbers({
							index,
							...accountDetails,
							value: accountNumber,
							valid: true,
							showLoader: false,
							isAlreadyApproved: false
						});
						callback && callback();
					}
					if(resp.status && resp.responseObject != false) {
						if (response.responseObject.length > 0 && response.responseObject.find(item => item.STATUS === "A") &&
							resp.responseObject.find(item => item.PURPOSE === 'SOLD_TO' && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'))
						) {
							isValidAccountNumber = true;
						};
						self.props.saveGEAccountNumbers({
							index,
							...accountDetails,
							value: accountNumber,
							valid: isValidAccountNumber,
							accountName: isValidAccountNumber?response.responseObject[0].ACCOUNTDESCRIPTION:"",
							showLoader: false,
							isAlreadyApproved: false
						});
						callback && callback();
					}else{
						isValidAccountNumber = false;
						self.props.saveGEAccountNumbers({
							index,
							...accountDetails,
							value: accountNumber,
							valid: isValidAccountNumber,
							accountName: isValidAccountNumber?response.responseObject[0].ACCOUNTDESCRIPTION:"",
							showLoader: false,
							isAlreadyApproved: false,
							soldToSiteAddress: false
						});
						callback && callback();
					}
				});
			});
		} else if(currentAccIsAlreadyApprovedOrPending && accountNumber !== "") {
			self.props.saveGEAccountNumbers({
				index,
				...accountDetails,
				value: accountNumber,
				valid: true,
				showLoader: false,
				isAlreadyApproved: true
			});
			// self.props.disableUpdateButton(false);
			callback && callback();
		}
	}

	doNothing(event) {
		event.preventDefault();
	}

	handlePrint(event) {
		event.preventDefault();
		window.print();
	}

	acceptNumbersOnly(event) {
		if(!(event.charCode >= 48 && event.charCode <= 57)){
			event.preventDefault();
		}
	}

	removeLocalStorageVar(variableName) {
		localStorage.removeItem(variableName);
	}

	getLocalStorageVar(variableName) {
		var localStrogeObj = localStorage.getItem(variableName);
		localStrogeObj = localStrogeObj?JSON.parse(localStrogeObj):null;
		return localStrogeObj;
	}


	manipulateProductSpecsData(productSpecsData) {
		// var productSpecsData = action.data;
		if(productSpecsData && productSpecsData.responseObject) {
			var orderOfSorting =['CAPACITY','FEATURES','ECONOMICAL / QUIET','APPEARANCE','WEIGHTS & DIMENSIONS','POWER / RATINGS','ACCESSORIES','WARRANTY','CERTIFICATIONS','FILTER','MISCELLANEOUS'],
				sortedFeaturesList = [];

			/*Set product details*/
			//set product data Group by definition and change it in proper json format
			var temp = productSpecsData.responseObject.attributes;
			temp = _.groupBy(temp, "definition");
			temp = window.convertToArrayOfObject(temp, 'groupBy');

			sortedFeaturesList = orderOfSorting.map((item,index) => {
				return _.find(temp, ['key',item]);
			});
			sortedFeaturesList = sortedFeaturesList.filter(function( element ) {
				return element !== undefined;
			});
			sortedFeaturesList.map((item,index)=>{
				item.list.sort(function(a, b){
					return a.Priority - b.Priority;
				});
				return null;
			})

			//Inherit sorted features list with existing attributes
			productSpecsData = {
				...productSpecsData,
				responseObject: {
					...productSpecsData.responseObject,
					sortedFeaturesList
				}
			}
		} else {
			productSpecsData.responseObject = 'NA'; // 'NA' means no data found for this sku
		}
		return productSpecsData;
	}

	checkAndSetSearchResult(typeOfSearch, accountNumber, zipCode, searchStr, navigationState, callback , skipAvailabilityCall = true) {
		var self = this;
		//get data
		self.props.getProductNumberKeywordResult(
			searchStr,
			navigationState,
			{
				accountNumber: accountNumber,
				zipCode: zipCode
			},
			typeOfSearch,
			(response) => {
				self.props.resetProductAvailabilityResultList();
				if(self.props.state.product.productNumberKeywordResult.length > 0) {
					// Make parallel availability call
					let productNumberKeywordResult = JSON.parse(JSON.stringify(self.props.state.product.productNumberKeywordResult));
					productNumberKeywordResult = productNumberKeywordResult.map(item => {
						return { sku: item.sku };
					});
					self.props.saveProductAvailabilityCallCompleted(false);
					// For prelogin second param is false even after its for availability as there wont be any ADC dropdown in prelogin
					zipCode && self.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
						if(resp && resp.agentid) {
							productNumberKeywordResult.length > 0 && self.checkAvailabilityAndOrderability(productNumberKeywordResult, `accountNumber=${accountNumber}&zipCode=${zipCode}&warehouseCode=${resp.agentid}`, self.getSelectedAddressParams(), 'searchresult', true, response => {
								self.props.saveProductResultAvailability(response);
								self.props.saveProductAvailabilityCallCompleted(true);
								setTimeout(() => {
									if(self.props.state.product.isProductAvailabilityCallCompleted) {
										self.props.updateAvailabilityForPreLogin();

										//Fetch filters if it is product line search
										if(typeOfSearch === 'product-line') {
											//get filters if product line is the type of search,
											//filter will be get once after getting actual available products only
											//Prepare list of sku list of available products
											const skuList = [];
											self.props.state.product.productNumberKeywordResult.forEach((item, index) => {
												skuList.push({
													"sku": item.sku
												});
											});
											self.props.getProductLineFilters(skuList, navigationState.replace("?", ""));
											callback && callback();
										}
										if(skipAvailabilityCall) {
											browserHistory.push('/prelogin/search-result/'+typeOfSearch);
										}
										else{
											callback && callback();
										}
									}
								}, 300);
							});
						}
					});
				} else {
					callback && callback();
				}
			},
			"prelogin"
		);
	}

	getSelectedAccountNumber() {
		const self = this;
		let accountNumber = self.props.state.user.accountDetail && self.props.state.user.accountDetail.input?self.props.state.user.accountDetail.input:'';
		return accountNumber;
	}

	getUrlParameter(name) {
	    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
	    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	    var results = regex.exec(location.search);
	    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	getZipCode() {
		return this.props.state.product.zipCode;
	}

	fireGTMTag(tagName, attributes) {
		triggerGTMTag(tagName, attributes);
	}

	checkItemOrderabilityInBatches(skuList, orderabilityQueryParams, whereToSave, showLoader, callback) {
		const self = this;
		const batches = _.chunk(skuList, self.state.itemOrderabilityBatchSize);
		self.setState({
			orderabilityBatchData: [],
			noOfCallRequired: batches.length,
			completedOrderabilityCall: 0
		}, () => {
			batches.forEach(item => {
				const queryString = `item=${item.join(',')}${orderabilityQueryParams || ''}`;
				self.props.checkItemOrderability(queryString, showLoader, (response) => {
					let orderabilityBatchData = self.state.orderabilityBatchData;
					if (response && response.responseObject) {
						orderabilityBatchData = orderabilityBatchData.concat(response.responseObject);
					}
					self.setState({
						orderabilityBatchData,
						completedOrderabilityCall: self.state.completedOrderabilityCall + 1
					}, () => {
						if (self.state.noOfCallRequired === self.state.completedOrderabilityCall) {
							callback && callback(self.state.orderabilityBatchData);
						}
					});
				});
			});
		});
	}

	checkAvailabilityGenericInBatches(skuList, queryStringParams, whereToSave, showLoader, callback, redirectError) {
		const self = this;
		const batches = _.chunk(skuList, pageSizeForGettingProductAvailability);
		self.setState({
			availabilityBatchData: [],
			noOfAvailabilityCallRequired: batches.length,
			completedAvailabilityCall: 0
		}, () => {
			batches.forEach(item => {
				self.props.checkAvailabilityGeneric(item, queryStringParams, whereToSave, showLoader, (response) => {
					let availabilityBatchData = self.state.availabilityBatchData;
					availabilityBatchData.push(response);
					self.setState({
						availabilityBatchData,
						completedAvailabilityCall: self.state.completedAvailabilityCall + 1
					}, () => {
						if (self.state.noOfAvailabilityCallRequired === self.state.completedAvailabilityCall) {
							callback && callback(self.state.availabilityBatchData);
						}
					});
				}, redirectError);
			});
		});
	}

	checkAvailabilityAndOrderability(payload, hybridQueryParams, orderabilityQueryParams, whereToSave, showLoader, callback, redirectError = true) {
		const self = this;
		self.setState({
			isAvailabilityCallCompleted: false,
			availabilityData: null,
			isOrderabilityCallCompleted: false,
			orderabilityData: null,
		}, () => {
			self.checkAvailabilityGenericInBatches(payload, hybridQueryParams, whereToSave, showLoader, (responses) => {
				const availabilityData = {
					...responses[0],
					responseObject: [],
				};
				responses.forEach(item => {
					availabilityData.responseObject = availabilityData.responseObject.concat(item.responseObject);
				});
				self.setState({
					isAvailabilityCallCompleted: true,
					availabilityData,
				}, () => {
					self.callBackAfterAvailabilityAndOrderability(whereToSave, callback);
				});
			}, redirectError);
			self.checkItemOrderabilityInBatches(payload.map(item => `'${item.sku}'`), orderabilityQueryParams, whereToSave, showLoader, (response) => {
				self.setState({
					isOrderabilityCallCompleted: true,
					orderabilityData: response,
				}, () => {
					self.callBackAfterAvailabilityAndOrderability(whereToSave, callback);
				});
			});
		});
	}

	callBackAfterAvailabilityAndOrderability(whereToSave, callback) {
		const self = this;
		const {
			isAvailabilityCallCompleted,
			availabilityData,
			isOrderabilityCallCompleted,
			orderabilityData,
		} = self.state;
		if (isAvailabilityCallCompleted && isOrderabilityCallCompleted) {
			// process availability data with orderability data
			const response = {
				...availabilityData,
				responseObject: []
			};
			if (availabilityData && availabilityData.responseObject && orderabilityData) {
				response.responseObject = availabilityData.responseObject.filter(item => {
					return orderabilityData.find(itm => itm.ITEM === item.sku && itm.ITEM_ORDERABILITY_FLAG === 'Y');
				});
			}
			callback && callback(response);
		}
	}

	getSelectedAddressParams() {
		const self = this;
		const zipCode = self.getZipCode();
		let queryString = `&state=&country=US&zip=${zipCode ? zipCode.split('-')[0] : zipCode}`;
		return queryString;
	}

    render() {
        return (
            <div>
                <Header />
                <div className="content">
                    {React.cloneElement(this.props.children, {
						doNothing: this.doNothing,
						manipulateProductSpecsData: this.manipulateProductSpecsData,
						handlePrint: this.handlePrint,
						fireGTMTag: this.fireGTMTag,
						formatETADate: this.formatETADate,
						checkAndSetSearchResult: this.checkAndSetSearchResult,
						acceptNumbersOnly: this.acceptNumbersOnly,
						getLocalStorageVar: this.getLocalStorageVar,
						removeLocalStorageVar: this.removeLocalStorageVar,
						getSelectedAccountNumber: this.getSelectedAccountNumber,
						getZipCode: this.getZipCode,
						validateAccountNumber: this.validateAccountNumber,
						getShippingAddressesDetails: this.getShippingAddressesDetails,
						checkIfFP: this.checkIfFP,
						validateFDD: this.validateFDD,
						checkAvailabilityAndOrderability: this.checkAvailabilityAndOrderability,
						getSelectedAddressParams: this.getSelectedAddressParams,
					})}
                </div>
				{this.props.state.loading.isFetching > 0 ? <Loader /> : null}
                <Footer fireGTMTag={this.fireGTMTag} hideFooterInfForPunchOut={false}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveProductLineNarrowYourResultsFilters: (data) => dispatch(saveProductLineNarrowYourResultsFilters(data)),
	getProductLineNarrorYourResultFilters: (payload) => dispatch(getProductLineNarrorYourResultFilters(payload)),
	checkAvailabilityGeneric: (payload, hybridQueryParams, whereToSave, showLoader, callback, redirectToError) => dispatch(checkAvailabilityGeneric(payload, hybridQueryParams, whereToSave, showLoader, callback, redirectToError)),
	getProductNumberKeywordResult: (searchStr, filters, params, typeOfSearch, callback, whichSearch) => dispatch(getProductNumberKeywordResult(searchStr, filters, params, typeOfSearch, callback, whichSearch)),
	getProductLineFilters: (payload, hybridQueryParams, callback) => dispatch(getProductLineFilters(payload, hybridQueryParams, callback)),
	updateAvailabilityForPreLogin: () => dispatch(updateAvailabilityForPreLogin()),
	saveGEAccountNumbers: (data) => dispatch(saveGEAccountNumbers(data)),
	saveProductAvailabilityCallCompleted: (data) => dispatch(saveProductAvailabilityCallCompleted(data)),
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	validateAccountNumber: (data, callback) => dispatch(validateAccountNumber(data, callback)),
	getShippingAddresses: (queryStringParams, showLoader, callback) => dispatch(getShippingAddresses(queryStringParams, showLoader, callback)),
	saveShippingAddresses: (data) => dispatch(saveShippingAddresses(data)),
	saveProductResultAvailability: (data) => dispatch(saveProductResultAvailability(data)),
	getAddressList: (queryStringParams, showLoader, callback) => dispatch(getAddressList(queryStringParams, showLoader, callback)),
	checkItemOrderability: (queryString, showLoader, callback) => dispatch(checkItemOrderability(queryString, showLoader, callback)),
});

PreLoginApp = connect(mapStateToProps, mapDispatchToProps)(PreLoginApp);
export default PreLoginApp;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/App.js